/* SAM custom: gate Add to Cart on required safe model/serial fields */
(function () {
  'use strict';

  function clearFieldError(input) {
    if (!input) return;
    input.classList.remove('is-invalid');
    var field = input.closest('.sam-safe-info__field');
    var error = field && field.querySelector('.sam-safe-info__error');
    if (error) error.classList.remove('is-visible');
  }

  function showFieldError(input) {
    if (!input) return;
    input.classList.add('is-invalid');
    var field = input.closest('.sam-safe-info__field');
    var error = field && field.querySelector('.sam-safe-info__error');
    if (error) error.classList.add('is-visible');
  }

  function validateSafeInfo(container) {
    var modelInput = container.querySelector('[data-safe-model-input]');
    var serialInput = container.querySelector('[data-safe-serial-input]');
    var modelValid = !!modelInput && modelInput.value.trim() !== '';
    var serialValid = !!serialInput && serialInput.value.trim() !== '';

    if (modelValid) {
      clearFieldError(modelInput);
    } else {
      showFieldError(modelInput);
    }

    if (serialValid) {
      clearFieldError(serialInput);
    } else {
      showFieldError(serialInput);
    }

    if (!modelValid && modelInput) {
      modelInput.focus();
    } else if (!serialValid && serialInput) {
      serialInput.focus();
    }

    return modelValid && serialValid;
  }

  /* Capture phase on document: runs before the theme's own delegated
     click handlers (variant-availability disable logic, ajax-cart submit),
     so we can block the click regardless of cart_action (redirect_cart,
     drawer, or mini_cart). */
  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('[data-add-to-cart-trigger]');
      if (!trigger) return;

      var productForm = trigger.closest('[data-product-form]');
      if (!productForm) return;

      var safeInfo = productForm.querySelector('[data-safe-info-fields]');
      if (!safeInfo) return;

      if (!validateSafeInfo(safeInfo)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        var warning = productForm.querySelector('.cart-warning');
        if (warning) {
          warning.textContent = "Please enter your safe's model and serial number before adding to cart.";
        }
      }
    },
    true
  );

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input.matches('[data-safe-model-input], [data-safe-serial-input]')) return;
    if (input.value.trim() !== '') {
      clearFieldError(input);
    }
  });
})();

/* SAM custom: sticky scroll-to-ATC bar. Never submits the form - only
   scrolls the real Add to Cart button back into view, so required PDP
   decisions (Lock Type, Safe Model/Serial) can't be bypassed. */
(function () {
  'use strict';

  var mainAtcButton = document.querySelector('[data-add-to-cart-trigger]');
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var stickyButton = document.querySelector('[data-sticky-atc-button]');
  var priceLineEl = document.querySelector('[data-sticky-atc-price-line]');

  if (!mainAtcButton || !stickyBar || !stickyButton) {
    return;
  }

  /* Mobile sits below the sticky header (top-anchored); desktop sits at
     the bottom (CSS handles that via the same 798px breakpoint), so the
     header-offset math below only applies on mobile. */
  var mobileQuery = window.matchMedia('(max-width: 798px)');

  /* Same technique the theme already uses for positioning .search-overlay
     under the sticky header (see jsHeader.enableSticky in utilities.js):
     measure the header's actual current position instead of assuming a
     fixed height, so this works whether sticky header is on or off, and
     whether it's currently engaged or still in normal flow. */
  function getHeaderOffset() {
    var header = document.getElementById('mobile-header');
    if (!header) return 0;
    var rect = header.getBoundingClientRect();
    return rect.top <= 5 && rect.bottom > 0 ? rect.bottom : 0;
  }

  /* Deterministic position check instead of IntersectionObserver: show once
     the real button's bottom edge has scrolled above the viewport entirely
     (rect.bottom is viewport-relative, so negative means "above"), hide
     again the moment scrolling back brings it level with or below the top
     of the viewport - i.e. genuinely "above the real ATC" again, not a
     direction guess. Re-checked on every scroll tick, so it self-corrects
     immediately either way. */
  function isScrolledPastButton() {
    return mainAtcButton.getBoundingClientRect().bottom < 0;
  }

  var scrollTicking = false;

  function updateStickyBar() {
    scrollTicking = false;
    if (isScrolledPastButton()) {
      stickyBar.style.top = mobileQuery.matches ? getHeaderOffset() + 'px' : '';
      stickyBar.classList.add('is-visible');
    } else {
      stickyBar.classList.remove('is-visible');
    }
  }

  window.addEventListener(
    'scroll',
    function () {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(updateStickyBar);
    },
    { passive: true }
  );

  updateStickyBar();

  stickyButton.addEventListener('click', function () {
    mainAtcButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* --- Desktop price line: live price on variant change ---
     Only does anything if priceLineEl exists (it's a desktop-only element,
     see CSS) and Shopify.formatMoney is available (assets/utilities.js,
     loaded before this file - guarded anyway per "keep JS defensive").

     Deliberately price-only for now, not a selected-options summary.
     Infinite Options (ShopPad) has more fields than just Extended
     Warranty (e.g. a separate Lock Type-style dropdown), and mapping all
     of them reliably needs more investigation - parked until/unless this
     bar becomes a real submit button, at which point full options
     coverage would be required anyway, not just nice-to-have. */
  if (priceLineEl && window.Shopify && typeof Shopify.formatMoney === 'function') {
    var variantSelection = document.querySelector('[data-variant-selection]');

    function formatMoney(cents) {
      return Shopify.formatMoney(cents, document.body.dataset.moneyFormat);
    }

    function renderPriceLine(variant) {
      if (!variant) return;
      priceLineEl.textContent = '';

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var strike = document.createElement('s');
        strike.textContent = formatMoney(variant.compare_at_price);
        priceLineEl.appendChild(strike);
        priceLineEl.appendChild(document.createTextNode(' '));
      }
      priceLineEl.appendChild(document.createTextNode(formatMoney(variant.price)));
    }

    if (variantSelection) {
      variantSelection.addEventListener('variant-change', function (event) {
        renderPriceLine(event.detail.variant);
      });

      if (variantSelection.getVariant) {
        variantSelection.getVariant().then(renderPriceLine);
      }
    }
  }
})();
